<template>
    <div class="custom-table-container">
        <table :class="['custom-table', { scrollable }]">
            <thead>
                <slot name="head" />
            </thead>
            <tbody>
                <slot name="body" />
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        scrollable: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.custom-table-container {
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    border: 1px solid $gray200;
    border-radius: $radiusMd;
    background: white;
    margin-top: 16px;
}
.custom-table-container::-webkit-scrollbar {
    height: 6px;
}
.custom-table-container::-webkit-scrollbar-track {
    background: transparent;
}
.custom-table-container::-webkit-scrollbar-thumb {
    background: $gray300;
    border-radius: 999px;
}
.custom-table-container::-webkit-scrollbar-thumb:hover {
    background: $gray400;
}

.custom-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-family: inherit;

    thead tr {
        background: $gray50;
    }
    th {
        font-weight: 600;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: $gray500;
        padding: 12px 20px;
        border-bottom: 1px solid $gray200;
        white-space: nowrap;
        text-align: left;
    }
    td {
        padding: 14px 20px;
        font-size: 13px;
        color: $gray700;
        border-bottom: 1px solid $gray100;
        vertical-align: middle;
    }
    tbody tr {
        transition: background $transitionFast;
    }
    tbody tr:hover {
        background: $gray50;
    }
    tbody tr:last-child td {
        border-bottom: none;
    }
}
.custom-table.scrollable td {
    min-width: 100px;
}

/* ---- Mobile ---- */
@media (max-width: 768px) {
    .custom-table {
        min-width: 600px;
    }
    .custom-table th {
        padding: 10px 14px;
        font-size: 10px;
    }
    .custom-table td {
        padding: 10px 14px;
        font-size: 12px;
    }
}
</style>
